import { render, staticRenderFns } from "./MemberWriteComponent.vue?vue&type=template&id=6056fe7a&scoped=true&"
import script from "./MemberWriteComponent.vue?vue&type=script&lang=js&"
export * from "./MemberWriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056fe7a",
  null
  
)

export default component.exports